import { render, staticRenderFns } from "./ItemwiseEntry.vue?vue&type=template&id=28c9008d"
import script from "./ItemwiseEntry.vue?vue&type=script&lang=js"
export * from "./ItemwiseEntry.vue?vue&type=script&lang=js"
import style0 from "./ItemwiseEntry.vue?vue&type=style&index=0&id=28c9008d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports